import {StorageService} from "./StorageService";

import {IEmployeeVm, ILoginViewModel, IMobileUser, ProxyContainer} from '../Data/Data';
import * as _ from "lodash"
import {RequestStatus} from '../../Cirrus/tlDataServices/DataResponse';

export class AuthenticationService {

  static serviceId: string = "authentication";
  static $inject: string[] = ["storage", "$q", "$proxy", "$interval", '$rootScope'];

  appUser: IMobileUser;
  loginData: ILoginViewModel;
  serverAvailable = true;
  pingInterval: ng.IPromise<any>;
  appUserReloadInterVall: ng.IPromise<any>;

  constructor(private storage: StorageService,
              private $q: ng.IQService,
              private $proxy: ProxyContainer,
              private $interval: ng.IIntervalService,
              private $rootScope: ng.IRootScopeService) {
    this.init();
  }

  private init() {
    this.loginData = this.storage.getLoginData();
    const appUser = this.storage.getCachedAppUser();
    this.setAppUser(appUser);
  }

  startAppUserReload() {
    this.appUserReloadInterVall = this.$interval(() => this.loadAppUser(), 5 * 60 * 1000);
  }

  startPinging() {
    this.ping();
    this.pingInterval = this.$interval(() => this.ping(), 15 * 1000);
  }

  async loadAppUser() {
    const appUser = this.storage.getCachedAppUser();
    this.setAppUser(appUser);
    this.$proxy.Account.getMobileUser().then(response => {
      const appUser = response.data;
      if (appUser) {
        this.setAppUser(appUser);
      }
    });

    return this.appUser;
  }

  async login(loginData: ILoginViewModel): Promise<IMobileUser> {
    const response = await this.$proxy.Account.mobileLogin(loginData);
    const token = response.httpReponse.headers('X-application-cookie');

    this.storage.setToken(token);
    const appUser = response.data;

    console.log('login', appUser);

    if (appUser) {
      this.storage.setLoginData(loginData);
      this.setAppUser(appUser);
      return appUser;
    } else if (response.httpReponse.status === 400) {
      this.setAppUser(null);
      this.appUser = null;
      return null;
    }
  }

  async logout() {
    this.storage.clearLoginData();
    this.storage.setAppUser(null);
    this.storage.setToken(null);
    try {
      await this.$proxy.Account.logout();
    } catch (err) {
      console.error(err);
    }
    try {
      const cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; ++i) {
        const myCookie = cookies[i];
        const pos = myCookie.indexOf("=");
        const name = pos > -1 ? myCookie.substr(0, pos) : myCookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    } catch (err) {
      console.error(err);
    }
  }

  ping() {
    this.$proxy.Account.ping().then(() => {
      this.serverAvailable = true;
    }, () => {
      this.serverAvailable = false;
    });
  }

  hasClaim(claim: string) {
    if (!this.appUser)
      return false;
    if (!this.appUser.person || !this.appUser.person.claims)
      return false;
    return _.includes(this.appUser.person.claims, claim);
  }

  hasClaimWithUser(claim: string, user: IEmployeeVm){
    if (!user)
      return false;
    if (!user.claims)
      return false;
    return _.includes(user.claims, claim);
  }

  async refreshLoginFromCredentials() {
    const loginData = this.storage.getLoginData();
    if (loginData) {
      await this.login(loginData);
      return
    }
    await this.logout();
    throw new Error(`No login data found, logout`);
  }

  private setAppUser(appUser: IMobileUser) {
    this.appUser = appUser;
    this.storage.setAppUser(appUser);
    this.$rootScope.$broadcast('appUserChanged', appUser);
  }
}
